import React  from 'react';
import { Link } from 'react-router-dom';



import Pricing from '../Components/Pricing/Pricing';
import Testimonial from '../Components/Testimonial/Testimonial';
import  videoExplain from '../Assets/img/VIDEO_EXPLICATIVE_PRESSING360.mp4'
const VideoPage = () => {

    return ( 
        <>
            <div className='container top'>
                <div className="row mt-5">
                    <h2 className='text-dark'>Explication du logiciel Pressing 360 </h2>
                    <p className='text-center mb-5'>Pourquoi vous aussi devez utiliser Pressing 360 ?</p>
                    <video  controls autoPlay className='rounded mx-auto d-block video-explication'>
                        <source src={videoExplain} type="video/mp4" />
                        Votre navigateur ne prend pas en charge la lecture de vidéos.
                    </video>
                    <div className='buttons'>
                        <Link to={'/'} className="btn  btn-danger text-white ">
                            <i className="fa-solid fa-house"></i> Retour à l'Accueil
                        </Link>
                        <Link to={`https://wa.me/2250788898998?text=Bonjour Elk-Tech Groupe, est-ce qu'il serait possible de discuter avec quelqu'un au sujet du logiciel Pressing 360? `} className="btn  btn-outline-dark" style={{ 'border': '0.5px solid black' }} >
                            <i className="fa-brands fa-whatsapp"></i> Parler à un commercial
                        </Link>
                    </div>
                </div>
            </div>

            <div id="pricing">
                <Pricing />
            </div>
            <div id="testimonial">
                <Testimonial />
            </div>
        </>
    );
};

export default VideoPage;
